import React, { useState } from 'react';
import './GuardLogs.css';

const sampleLogs = [
  {
    id: 1,
    date: '2026-11-04',
    time: '08:00',
    officer: 'J. Ahmed',
    site: 'Construction Site – Castle Vale',
    type: 'Patrol',
    notes: 'Perimeter patrol completed. All gates secured. No incidents.',
    status: 'Clear',
  },
  {
    id: 2,
    date: '2026-11-04',
    time: '12:30',
    officer: 'M. Khan',
    site: 'Retail – Birmingham City Centre',
    type: 'Incident',
    notes: 'Suspected shoplifter detained and handed to police. Crime ref: WM-2026-0441.',
    status: 'Incident',
  },
  {
    id: 3,
    date: '2026-11-04',
    time: '20:00',
    officer: 'S. Patel',
    site: 'Solar Panel Site – Coventry',
    type: 'Patrol',
    notes: 'Night patrol completed. All equipment secure. CCTV operational.',
    status: 'Clear',
  },
  {
    id: 4,
    date: '2026-11-03',
    time: '09:15',
    officer: 'D. Williams',
    site: 'Corporate – Solihull Office',
    type: 'Access Control',
    notes: 'Visitor log checked. 14 visitors processed. All IDs verified.',
    status: 'Clear',
  },
  {
    id: 5,
    date: '2026-11-03',
    time: '22:45',
    officer: 'J. Ahmed',
    site: 'Building Site – Erdington',
    type: 'Alarm Response',
    notes: 'Perimeter alarm triggered – cause: stray animal. Reset and logged.',
    status: 'Resolved',
  },
];

const statusColors = {
  Clear: '#27ae60',
  Incident: '#e74c3c',
  Resolved: '#f39c12',
};

const LogRow = ({ log }) => (
  <tr>
    <td>{log.date}</td>
    <td>{log.time}</td>
    <td>{log.officer}</td>
    <td>{log.site}</td>
    <td>
      <span className={`log-type-badge log-type-${log.type.toLowerCase().replace(' ', '-')}`}>
        {log.type}
      </span>
    </td>
    <td className="log-notes">{log.notes}</td>
    <td>
      <span
        className="log-status-badge"
        style={{ backgroundColor: statusColors[log.status] || '#7f8c8d' }}
      >
        {log.status}
      </span>
    </td>
  </tr>
);

const GuardLogs = () => {
  const [filterSite, setFilterSite] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterType, setFilterType] = useState('');

  const sites = [...new Set(sampleLogs.map((l) => l.site))];
  const statuses = [...new Set(sampleLogs.map((l) => l.status))];
  const types = [...new Set(sampleLogs.map((l) => l.type))];

  const filtered = sampleLogs.filter((l) => {
    return (
      (!filterSite || l.site === filterSite) &&
      (!filterStatus || l.status === filterStatus) &&
      (!filterType || l.type === filterType)
    );
  });

  return (
    <div className="logs-container">
      {/* Hero */}
      <div className="logs-hero">
        <div className="logs-hero-overlay" />
        <div className="logs-hero-content">
          <span className="logs-hero-tag">TRANSPARENCY &amp; ACCOUNTABILITY</span>
          <h1>Guard Activity Logs</h1>
          <p>A full record of patrol activities, access control events, and incident reports across all client sites.</p>
        </div>
      </div>

      {/* Summary Cards */}
      <section className="logs-summary">
        <div className="logs-summary-card">
          <span className="summary-num">{sampleLogs.length}</span>
          <span className="summary-label">Total Entries</span>
        </div>
        <div className="logs-summary-card">
          <span className="summary-num">{sampleLogs.filter((l) => l.status === 'Clear').length}</span>
          <span className="summary-label">Clear</span>
        </div>
        <div className="logs-summary-card incident">
          <span className="summary-num">{sampleLogs.filter((l) => l.status === 'Incident').length}</span>
          <span className="summary-label">Incidents</span>
        </div>
        <div className="logs-summary-card resolved">
          <span className="summary-num">{sampleLogs.filter((l) => l.status === 'Resolved').length}</span>
          <span className="summary-label">Resolved</span>
        </div>
      </section>

      {/* Filters */}
      <section className="logs-filters">
        <div className="logs-filter-inner">
          <label>
            Site
            <select value={filterSite} onChange={(e) => setFilterSite(e.target.value)}>
              <option value="">All Sites</option>
              {sites.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </label>
          <label>
            Type
            <select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
              <option value="">All Types</option>
              {types.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
          </label>
          <label>
            Status
            <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
              <option value="">All Statuses</option>
              {statuses.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </label>
          {(filterSite || filterStatus || filterType) && (
            <button
              className="logs-clear-btn"
              onClick={() => { setFilterSite(''); setFilterStatus(''); setFilterType(''); }}
            >
              Clear Filters
            </button>
          )}
        </div>
      </section>

      {/* Logs Table */}
      <section className="logs-table-section">
        <div className="logs-table-wrapper">
          {filtered.length === 0 ? (
            <p className="logs-empty">No log entries match your filters.</p>
          ) : (
            <table className="logs-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Officer</th>
                  <th>Site</th>
                  <th>Type</th>
                  <th>Notes</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((log) => <LogRow key={log.id} log={log} />)}
              </tbody>
            </table>
          )}
        </div>
        <p className="logs-disclaimer">
          Logs shown are for demonstration. Client-specific secure log access is available via the client dashboard.
        </p>
      </section>
    </div>
  );
};

export default GuardLogs;
